import React, { useState } from "react";
import { date } from "../../../utils/dateTime";
import Gap from "../../../components/Gap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";

//material
import Typography from "@material-ui/core/Typography";
import Backdrop from "@material-ui/core/Backdrop";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
// import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import RedeemIcon from "@material-ui/icons/Redeem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import IconDelivery from "../../../assets/icon/icon-delivery";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidSecondList: {
    maxWidth: "200px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  liquidRed: {
    fontSize: 12,
    color: "red",
  },
  wrapCard: {
    textAlign: "center",
  },
  img: {
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(min-width: 280px)": {
      height: 128,
    },
    "@media(min-width: 320px)": {
      height: 148,
    },
    "@media(min-width: 360px)": {
      height: 168,
    },
    "@media(min-width: 960px)": {
      height: 270,
    },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    paddingLeft: 4,
    paddingRight: 4,
    marginBottom: 15,
    "@media(min-width: 280px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 320px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 360px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 400px)": {
      width: "calc(100%/2)",
      height: "100%",
    },
    "@media(min-width: 600px)": {
      width: "calc(100%/3)",
      height: "100%",
    },
    "@media(min-width: 960px)": {
      width: "calc(100%/4)",
      height: "100%",
    },
  },
}));

function ListItemMap({ data }) {
  const classes = useStyles();
  const { id, status, created_at, resi_pengiriman_reward, bukti_pengiriman } =
    data;
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [openB, setOpenB] = useState(false);
  const [copied, setCopied] = useState(true);
  const point = data.total_penukaran_reward
    ? data.total_penukaran_reward
    : data.nilai;

  const title = data.total_penukaran_reward
    ? "Penukaran Reward"
    : "Point penjualan";

  let appro = data.status == "approved";
  const tampilan = appro ? data.status : null;

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseB = () => {
    setOpenB(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const handleToggleB = () => {
    setOpenB(!openB);
  };

  const bagikan = () => {
    setCopied(true);
    enqueueSnackbar("Resi di salin", { variant: "success" });
  };

  return (
    <>
      <ListItem button>
        <ListItemIcon>
          {data.total_penukaran_reward ? (
            <RedeemIcon color="primary" />
          ) : (
            <AttachMoneyIcon color="primary" />
          )}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography className={classes.liquidPrimary}>{title}</Typography>
          }
          secondary={
            <div>
              <Typography className={classes.liquidSecondList}>
                #{id}{" "}
              </Typography>

              <Typography className={classes.liquidSecondList}>
                {created_at && date(created_at.toDate())}
              </Typography>
            </div>
          }
        />
        <ListItemSecondaryAction>
          <Typography className={classes.liquidThird}>{point}</Typography>
          <Typography
            className={
              status === "rejected" ? classes.liquidRed : classes.liquidThird
            }
          >
            {status}
          </Typography>
        </ListItemSecondaryAction>
      </ListItem>
      {tampilan ? (
        <ListItem style={{ justifyContent: "center" }}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            disabled={!resi_pengiriman_reward}
            color="primary"
            onClick={handleToggle}
          >
            Resi
          </Button>
          <Gap width={30} />
          <Button
            fullWidth
            disabled={!bukti_pengiriman}
            variant="contained"
            size="small"
            color="primary"
            onClick={handleToggleB}
          >
            Tracking
          </Button>
        </ListItem>
      ) : null}

      <Divider />
      <Backdrop
        className={classes.backdrop}
        open={openB}
        onClick={handleCloseB}
      >
        <div className={classes.wrapper}>
          <img
            loading="lazy"
            src={bukti_pengiriman}
            alt="bukti"
            className={classes.img}
            // style={{
            //   backgroundImage: `url(${item.thumbnail[0]})`,
            // }}
          />{" "}
        </div>
      </Backdrop>
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <Card>
          <CardContent className={classes.wrapCard}>
            <IconDelivery height={130} width={100} />
            <Typography>Nomor Resi Pengiriman</Typography>
            <CardActions>
              <Typography>{resi_pengiriman_reward}</Typography>
              <CopyToClipboard text={resi_pengiriman_reward} onCopy={bagikan}>
                <IconButton>
                  <FileCopyIcon color="primary" fontSize="small" />
                </IconButton>
              </CopyToClipboard>
            </CardActions>
          </CardContent>
        </Card>
      </Backdrop>
    </>
  );
}

export default ListItemMap;
